export default {
  roleTypes: [],
  doctors: [],
  admins: [],
  lab_technicians: [],
  nurses: [],
  medicalStaffForDropdown: [],
  operators: [],
  allUsers: [],
  linesOfWork: [],
  linesOfWorkTypes: [],
  directionsPerPage: [],
  directionsPerPageCount: 0,
  directions: [],
  directionsForDropdown: [],
  directionSettings: null,
  departmentsPerPage: [],
  departmentsPerPageCount: 0,
  departments: [],
  integratorBranches: [],
  userIntegratorBranches: [],
  userOfficePhoneNumbersPerPage: [],
  userOfficePhoneNumbersPerPageCount: 0
}
